var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.time.length > 0),expression:"time.length > 0"}],staticClass:"save-time"},[_vm._v(_vm._s(_vm.time)+"保存成功")])}
var staticRenderFns = []

export { render, staticRenderFns }